<template>
  <div class="contact">
    <!-- Hero banner -->
    <section class="contact-hero">
      <img class="contact-hero__bg" src="https://qiniu.shunmingelectronic.com/guanwang/product/lianxiwomen.jpg"
        alt="联系我们" />
      <div class="contact-hero__overlay"></div>
      <div class="km-container contact-hero__content">
        <span class="km-eyebrow">CONTACT US</span>
        <h1 class="km-h1">联系我们</h1>
        <p class="km-lead contact-hero__lead">告诉我们您的目标与需求，我们将以清晰的思路为您提供下一步方案。</p>
      </div>
    </section>

    <section class="km-section">
      <div class="km-container contact-grid">
        <!-- Info -->
        <div class="contact-info">
          <div class="contact-info__item km-card">
            <span class="contact-info__label">公司名称</span>
            <span class="contact-info__value">河南舜铭电子信息科技有限公司</span>
          </div>
          <div class="contact-info__item km-card">
            <span class="contact-info__label">公司地址</span>
            <span class="contact-info__value">中国（河南）自由贸易试验区洛阳片区（高新）丰华路1号803-3</span>
          </div>
          <div class="contact-info__item km-card">
            <span class="contact-info__label">联系电话</span>
            <span class="contact-info__value">0379-63220552<br>+86 18338857570 &nbsp; +86 18848974218<br>+86 16662992205</span>
          </div>
          <div class="contact-info__item km-card">
            <span class="contact-info__label">邮箱</span>
            <span class="contact-info__value">bright_xu@sina.cn</span>
          </div>
        </div>

        <!-- QR -->
        <div class="contact-qr km-card">
          <span class="contact-qr__label">微信扫码 · 与我们对话</span>
          <div class="contact-qr__img">
            <img src="../assets/fswxh.png" alt="微信二维码" />
          </div>
          <span class="contact-qr__hint">扫描上方二维码添加微信</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactView'
}
</script>

<style scoped>
.contact {
  background: var(--bg);
}

.contact-hero {
  position: relative;
  min-height: 420px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.contact-hero__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.contact-hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.72) 60%, var(--bg) 100%);
}

.contact-hero__content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  padding-top: 80px;
}

.contact-hero__content .km-h1 {
  color: #fff;
}

.contact-hero__content .km-eyebrow {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.10);
}

.contact-hero__lead {
  max-width: 520px;
  color: rgba(255, 255, 255, 0.82);
}

.contact-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 28px;
  align-items: start;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.contact-info__item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 26px 30px;
  text-align: left;
}

.contact-info__label {
  font-family: var(--font-display);
  font-size: 13px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--accent);
}

.contact-info__value {
  color: var(--text);
  font-size: 17px;
  line-height: 1.7;
}

.contact-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 40px 32px;
  text-align: center;
  position: sticky;
  top: 110px;
}

.contact-qr__label {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 17px;
  color: var(--text);
}

.contact-qr__img {
  width: 220px;
  max-width: 100%;
  border-radius: var(--radius);
  overflow: hidden;
  background: #fff;
  padding: 14px;
}

.contact-qr__img img {
  width: 100%;
  display: block;
}

.contact-qr__hint {
  color: var(--text-soft);
  font-size: 14px;
}

@media (max-width: 900px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }

  .contact-qr {
    position: static;
  }
}
</style>
